import { demo1, demo2, demo3, demo4, demo5 } from "helper/constant";

export const bestDemos = [
  {
    id: 1,
    sidebarTheme: "gredient1",
    topbarTheme: "gredient1",
    footerTheme: "gredient1",
    layoutTheme: "themedefault",
    layout: "vertical",
    activeLinkStyle: "style1",
    demo: demo1,
    name: "Default"
  },
  {
    id: 2,
    sidebarTheme: "gredient4",
    topbarTheme: "gredient4",
    footerTheme: "gredient4",
    layoutTheme: "themedefault",
    layout: "horizontal",
    activeLinkStyle: "style1",
    demo: demo2,
    name: "Horizontal Layout"
  },
  {
    id: 3,
    sidebarTheme: "dark",
    topbarTheme: "dark",
    footerTheme: "dark",
    layoutTheme: "theme7",
    layout: "vertical",
    demo: demo3,
    activeLinkStyle: "style3",
    name: "Dark"
  },
  {
    id: 4,
    sidebarTheme: "light",
    topbarTheme: "light",
    footerTheme: "light",
    layoutTheme: "theme1",
    layout: "vertical",
    activeLinkStyle: "style2",
    demo: demo4,
    name: "Light"
  },
  {
    id: 4,
    sidebarTheme: "sky",
    topbarTheme: "sky",
    footerTheme: "sky",
    layoutTheme: "theme1",
    layout: "vertical",
    activeLinkStyle: "style3",
    demo: demo5,
    name: "Sky"
  }
];
